import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLIENTS_PROJECTS_RESET } from '../../../redux/constantes/clientsProjects';

import { ContainerForm } from '../../../components/Containers';
import InputCompany from '../../../components/Company/InputCompany';
import { WrapperButtons } from '../../../components/Company/WrapperButtons';
import ButtonSend from '../../../components/ButtonSend';
import ButtonBack from '../../../components/ButtonBack';
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import HeaderTitle from '../../../components/HeaderTitle';
import SubTitleWrapper from '../../../components/SubTitleWrapper';
import { CreateClientsProjectsAction, SearchClientsProjectsAction } from '../../../redux/actions/clientsProjects';
import ClientProjectOption from '../../../components/SincronizaNFe/ClientProjectOption';
import SelectCompanySincroniza from '../../../components/SincronizaNFe/SelectCompanySincroniza';
import { WrapperListClientProjectsCompanies } from '../../../components/WrapperListClientProjectsCompanies';
import InputSearch from '../../../components/InputSearch';

export default function TemplateCreateClientsProjectsAndCompanies() {
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [errorCompany, setErrorCompany] = useState(false);
  const [searchProject, setSearchProject] = useState('');

  const { success: successCreateClientsProjects, error: errorCreateClientsProjects } = useSelector(
    (state) => state.createClientsProjects,
  );
  const { clientsProjects: searchClientsProjects, error: searchClientsProjectsError } = useSelector(
    (state) => state.searchClientsProjects,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchClientsProjectsError === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [searchClientsProjectsError]);

  useEffect(() => {
    dispatch(SearchClientsProjectsAction());
  }, [dispatch]);

  useEffect(() => {
    if (successCreateClientsProjects) {
      setTimeout(() => {
        dispatch({ type: CLIENTS_PROJECTS_RESET });
        document.location.href = '/sincroniza-nfe/registro-cliente-projeto-empresa';
      }, 3000);
    }
    if (errorCreateClientsProjects) {
      setTimeout(() => {
        dispatch({ type: CLIENTS_PROJECTS_RESET });
      }, 3000);
    }
  }, [dispatch, successCreateClientsProjects, errorCreateClientsProjects]);

  useEffect(() => {
    if (company === 'Sincroniza Educação') {
      setCnpj('1');
    } else if (company === 'Sincroniza Projetos') {
      setCnpj('2');
    } else {
      setCnpj('0');
    }
  }, [company]);

  const handleSubmit = () => {
    if (company === '0') {
      setErrorCompany(true);
      return;
    }
    dispatch(CreateClientsProjectsAction(name, company, cnpj));
  };

  const filteredProjects = searchProject
    ? searchClientsProjects.filter((clientProj) => {
        return clientProj.name.toLowerCase().includes(searchProject.toLowerCase());
      })
    : searchClientsProjects;

  return (
    <ContainerForm>
      <HeaderTitle text="Cadastrar Clientes - Projetos - Empresas" linkIcon="/images/icons/configuration2.svg" />
      <InputCompany
        id="name"
        label="Nome do Cliente - Projeto"
        type="text"
        onChange={(e) => setName(e.target.value)}
        value={name}
        placeholder="Exemplo: Abeaço-Ed. Ambiental-2021"
      />
      <SelectCompanySincroniza setErrorCompany={setErrorCompany} setCompany={setCompany} value={company} />
      <WrapperButtons>
        <ButtonBack />
        <ButtonSend onClick={handleSubmit}>Cadastrar</ButtonSend>
      </WrapperButtons>
      <div>
        <SubTitleWrapper subTitle="Cadastros" />
        <InputSearch
          placeholder="Digite o nome do Projeto para acha-lo"
          state={searchProject}
          setState={setSearchProject}
        />
        <WrapperListClientProjectsCompanies>
          {filteredProjects &&
            filteredProjects.map((clientProj, index) => (
              <ClientProjectOption key={index + 1} clientProj={clientProj} />
            ))}
        </WrapperListClientProjectsCompanies>
      </div>
      {errorCreateClientsProjects && <MessageBoxError>{errorCreateClientsProjects}</MessageBoxError>}
      {successCreateClientsProjects && <MessageBoxSuccess>Empresa cadastrada com sucesso!</MessageBoxSuccess>}
      {errorCompany && <MessageBoxError>Ops... Você não escolheu empresa!</MessageBoxError>}
    </ContainerForm>
  );
}
